import React, { Component } from 'react';
import './style.scss';
import { connect } from 'react-redux';
import { getPartner } from '../../service/partners/selector';
import PartnerContainer from '../PartnerContainer';
import { deepEqual } from '../../utils';
import Config from '../../Components/Config';
import { getData } from '../../service/partnersData/actions';
import { bindActionCreators } from 'redux';
import { setSelected } from '../../Components/ProductsSelector/service/products/actions';
import SupplementManager from '../../Components/SupplementExtra';
import PaymentAsso from '../../Components/Binding';
import { I18n } from 'react-redux-i18n';
import Options from '../../Components/Options';
import ChildrenLink from '../../Components/ChildrenLink';
import { getChildId } from '../../../../Components/MasterBar/service/saga';

class Belorder extends Component {
	render() {
		const { partner } = this.props;

		return (
			<PartnerContainer
				name={I18n.t(`partner.prefix.${partner.prefix}`)}
				id={partner ? partner.id : null}
				prefix={partner ? partner.prefix : null}>
				{!this.props.connectAsMaster ? (
					<>
						<div className="gestion-button-container">
							<div className="gestion-button">
								<SupplementManager prefix={partner.prefix} />
								<PaymentAsso prefix={partner.prefix} />
							</div>
						</div>
						<Options prefix_partner={partner.prefix || ''} />
						<Config prefix_partner={partner.prefix || ''} />

						<Config prefix_partner={partner.prefix || ''} />
					</>
				) : (
					''
				)}

				<ChildrenLink prefix={partner ? partner.prefix : null} />
			</PartnerContainer>
		);
	}
}

const mapStateToProps = (state, props) => {
	const partner = getPartner(state, props);
	const data = state.partnersData[partner.prefix];
	const connectAsMaster = state.service.user.children.length && !getChildId();
	return {
		connectAsMaster,
		children: state.service.user.children,
		partner,
		partnerData: data,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		getPartnerData: _ => dispatch(getData('belorder')),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Belorder);
